import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedType: null,
  selectedItems: [],
};

const ticketsSlice = createSlice({
  name: "tickets",
  initialState,
  reducers: {
    selectType: (state, action) => {
      state.selectedType = action.payload;
      state.selectedItems = [];
    },
    toggleItem: (state, action) => {
      const item = action.payload;
      if (state.selectedItems.includes(item)) {
        state.selectedItems = state.selectedItems.filter((i) => i !== item);
      } else {
        state.selectedItems.push(item);
      }
    },
  },
});

export const { selectType, toggleItem } = ticketsSlice.actions;

export default ticketsSlice.reducer;
